import * as types from './types';
import {UserAction} from '../_reducers/user';
import {User} from '../_services/User';

export function userAuthenticated(): UserAction {
    return {type: types.USER_AUTHENTICATED}
}

export function logout(): UserAction {
    User.getInstance().deleteAuthToken();
    return {type: types.USER_NOT_AUTHENTICATED}
}
